import React from 'react';
import ProfileLink from '../../../profile-link/profile-link';
import { useConfiguration } from '../../../../context/configuration-context/use-configuration';
import { AUTHOR } from '../../../../../common/constants/data-hooks';
import BadgeLazy from '../../../badge/badge-lazy';
import TextExtended from '../../../text-extended/text-extended';
import { useTranslate } from '../../../../context/api-context/translations/use-translate';
import { UserAvatar } from '../../../user-avatar/user-avatar';
import { useApi } from '../../../../api-provider';
import { getIsMobile } from '../../../../../common/store/base-params/base-params-selectors';
import { st, classes } from './owner-info.st.css';
import { ReactionIcon } from '../../../../../reactions';
import { getReactionName } from '../../../../../reactions/utils/reaction-converters';
const OwnerInfo = ({ owner, showReaction, mainReactionName, showAvatars = true }) => {
    var _a, _b, _c, _d, _e;
    const { roleIcons, hideBadge } = useConfiguration();
    const isMobile = useApi(getIsMobile);
    const t = useTranslate();
    const { memberBadge, memberRole, member } = owner.type === 'MEMBER'
        ? {
            memberBadge: (_c = (_b = (_a = owner.member) === null || _a === void 0 ? void 0 : _a.memberBadges) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : undefined,
            memberRole: (_e = (_d = owner.member) === null || _d === void 0 ? void 0 : _d.memberRoles) === null || _e === void 0 ? void 0 : _e[0],
            member: owner.member,
        }
        : {
            memberBadge: undefined,
            memberRole: undefined,
            member: undefined,
        };
    const RoleIcon = memberRole && (roleIcons === null || roleIcons === void 0 ? void 0 : roleIcons[memberRole]);
    const renderAvatar = () => showReaction ? (React.createElement("div", { className: classes.avatarWithReaction },
        React.createElement(UserAvatar, { className: classes.avatar, owner: owner }),
        owner.reactionCode ? (React.createElement("div", { className: classes.reactionContainer },
            React.createElement(ReactionIcon, { className: classes.reactionIcon, reactionName: getReactionName(owner.reactionCode, mainReactionName) }))) : null)) : (React.createElement(UserAvatar, { className: classes.avatar, owner: owner }));
    return (React.createElement("div", { className: st(classes.root, { isMobile }) },
        showAvatars ? renderAvatar() : null,
        React.createElement("div", { className: classes.content },
            React.createElement(ProfileLink, { className: classes.row, member: member },
                React.createElement(TextExtended, { priority: "black", dataHook: AUTHOR, className: classes.username, typography: "contentSmall", size: "custom" }, owner.type === 'ANONYMOUS'
                    ? t('user-info.guest-commenter', { id: undefined })
                    : owner.member.profile.nickname),
                RoleIcon ? (React.createElement("div", { className: classes.role },
                    React.createElement(RoleIcon, null))) : null),
            React.createElement("div", { className: classes.row }, memberBadge && !hideBadge && (React.createElement(BadgeLazy, { className: classes.badge, badge: memberBadge, layout: "name-only" }))))));
};
export default OwnerInfo;
//# sourceMappingURL=owner-info.js.map